import VueRouter from 'vue-router'
import swal from 'sweetalert2'
import routes from './routes'
import { $can } from 'src/mixins/can'
import CouchdbClass from 'src/services/CouchdbClass'
import store from 'src/vuex/store'

const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
})

const projectCouchdb = new CouchdbClass({ connection: 'config', collection: 'projects' })

function hasConfig (store) {
  return store.hasOwnProperty('state') && store.state.hasOwnProperty('config') && store.state.config.hasOwnProperty('_id') && store.state.config.hasOwnProperty('state')
}

router.beforeEach((to, from, next) => {
  if (!hasConfig(store)) {
    projectCouchdb.find('config').then(result => {
      store.commit('changeConfig', result)
      store.dispatch('project/setStateOne', result, { root: true })
      // store.modules.project.actions.setStateOne(result)
    }).catch(err => console.log('can not store config', err))
  }
  let permissionPage = $can(to.name, JSON.parse(localStorage.getItem('user')))
  let isLoggedIn = (localStorage.getItem('isLoggedIn') === 'true')
  let requireAuth = to.meta.requireAuth
  if (requireAuth === undefined) {
    requireAuth = false
  }

  if (to.path === '/login') {
    // if (localStorage.getItem('isLoggedIn')) {
    //   next('/admin/overview')
    // }
    next()
    return
  }

  if (requireAuth && !isLoggedIn) {
    swal({
      title: 'Você não está logado!',
      text: 'Primeiro você deve logar-se no sistema.',
      buttonsStyling: false,
      confirmButtonClass: 'btn btn-success btn-fill',
      type: 'error'
    })
    next('/login')
    return
  }

  // Se a rota requer autenticação, e o usuário está logado, e tem permissão para ver a página.
  if (requireAuth && isLoggedIn) {
    if (!permissionPage && to.fullPath !== '/admin/dashboard') {
      swal({
        title: 'Sem permissão!',
        text: 'Você não tem permissão para ver está página.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        type: 'error'
      })
      next('/admin/dashboard')
    } else {
      next()
    }
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js